import { render, staticRenderFns } from "./HisData.vue?vue&type=template&id=22314831&scoped=true&"
import script from "./HisData.vue?vue&type=script&lang=js&"
export * from "./HisData.vue?vue&type=script&lang=js&"
import style0 from "./HisData.vue?vue&type=style&index=0&id=22314831&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22314831",
  null
  
)

export default component.exports